import React, { Component } from 'react';
import {HashRouter as Router, Switch, Redirect, Route, withRouter} from 'react-router-dom';
import Main from './modules/main/main';
import Slider from './modules/slider/slider';
import Tour from './modules/tour/tour';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children || null
  }
}

ScrollToTop = withRouter(ScrollToTop)

const App = () => {
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/main" />} />
          <Route component={Main} path="/main" />
          <Route component={Tour} path="/tour" />
          <Route path="/page/:slug" 
              render={({match}) => <Slider currentPage={parseInt(match.params.slug, 10) || 0} />}
          />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
